/**
 * description: 微博定时签发-设置签发时间弹窗
 * author: Qian.qianchen 2018-11-20
 */
'use strict';
angular.module('editingCenterAppFocusModule').controller('appFocusTimingCtrl', [
    '$scope',
    '$stateParams',
    '$modalInstance',
    'options',
    'trsspliceString',
    'appFocusApiService',
    function(
        $scope,
        $stateParams,
        $modalInstance,
        options,
        trsspliceString,
        appFocusApiService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                params: {
                    ChannelId: $stateParams.channelid,
                    ChnlDocIds: trsspliceString.spliceString(options.itemArr, 'RECID', ','),
                    isSchedule: false,
                    ScheduleUpTime: '',
                    position: '1',
                    ScheduleDownTime: '',
                },
                isTiming: false,
                // timingTime: new Date(new Date().getTime() + 5 * 60 * 1000), // 默认时间定为往后推迟5分钟，避免点击确定时后端提示
                timingDate: new Date(),
                timeClear: false,
                dateClear: false,
                modalTitle: options.type ? '上架' : '下架',
                isUpdate: false,
                later: 5, // 默认时间定为往后推迟5分钟，避免点击确定时后端提示
                isShowAfterTip: false, // 上架位置后面是否显示‘之后’提示
            };
            $scope.data = {
                upLocations:[
                    {'name': '最后面', value: '0'},
                    {'name': '最前面', value: '-1'}
                ],
                selectedLocation: {},
            };
            $scope.status.timingTime = new Date(new Date().getTime() + $scope.status.later * 60 * 1000);
        }

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}       [return description]
         */
        function initData(){
            getOnlineFocusList();
        }

        /**
         * [获取在线的焦点图列表]
         */
        function getOnlineFocusList(){
            let params = {
                PageSize: 1000,
                PageIndex: 1,
                ChannelId: $stateParams.channelid,
                SearchContent: '',
            };
            appFocusApiService.getFocusQueue(params).then(function(data){
                if (data.length) { 
                    angular.forEach(data, function(item, index){
                        let tmp = {
                            name: item.FOCUSIMGTITLE,
                            value: item.RECID,
                        };
                        $scope.data.upLocations.push(tmp);
                    });
                }
                $scope.data.selectedLocation = $scope.data.upLocations[0];
            });
        }

        /**
         * [dateFormat description] 日期整理
         * @param  {[Date]} date    [description] 日期
         * @param  {[String]} getType [description] 需要的时间段
         * @return {[type]}         [description]
         */
        function dateFormat(date, getType) {
            if (angular.isDefined(date) && date) {
                var d = new Date(date);
                if (getType === 'date') {
                    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                } else {
                    return (
                        (d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) +
                        ':' +
                        (d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()) +
                        ':' +
                        (d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds())
                    );
                }
            } else {
                return '';
            }
        }


        /**
         * [clearDateTime description] 清除时间
         * @param  {[string]} type [description] 时间/日期
         * @return {[type]}      [description]
         */
        $scope.clearDateTime = function(type) {
            if (type === 'date') {
                $scope.status.signDate = '';
            } else {
                $scope.status.signTime = '';
            }
        };

        /**
         * [mouseEnter description] 时间控件鼠标进入方法
         * @param  {[string]} type [description] 时间/日期
         * @return {[type]}      [description]
         */
        $scope.mouseEnter = function(type) {
            if (type === 'date') {
                $scope.status.dateClear = $scope.status.signDate !== '';
                $('.date_input').css({ color: '#000' });
            } else {
                $scope.status.timeClear = $scope.status.signTime !== '';
            }
        };

        /**
         * [mouseOut description] 时间控件鼠标移除方法
         * @param  {[string]} type [description] 时间/日期
         * @return {[type]}      [description]
         */
        $scope.mouseOut = function(type) {
            if (type === 'date') {
                $scope.status.dateClear = false;
            } else {
                $scope.status.timeClear = false;
            }
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定按钮
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            if ($scope.status.isTiming) {
                $scope.status.params.isSchedule = true;
                if (options.type) {
                    $scope.status.params.ScheduleUpTime = dateFormat($scope.status.timingDate, 'date') + ' ' + dateFormat($scope.status.timingTime, 'time');
                } else {
                    $scope.status.params.ScheduleDownTime = dateFormat($scope.status.timingDate, 'date') + ' ' + dateFormat($scope.status.timingTime, 'time');
                    
                }
            }
            if (options.type){
                if ($scope.data.selectedLocation.value === '-1') {
                    $scope.status.params.position = '0';
                    $scope.status.params.ToChnlDocId = $scope.data.upLocations[2].value;
                } else if ($scope.data.selectedLocation.value === '0') {
                    $scope.status.params.ToChnlDocId = $scope.data.upLocations[$scope.data.upLocations.length - 1].value;
                } else {
                    $scope.status.params.ToChnlDocId = $scope.data.selectedLocation.value;
                }
                appFocusApiService.FocusUp($scope.status.params).then(function(data){
                    $modalInstance.close(data);
                });
            } else {
                appFocusApiService.FocusDown($scope.status.params).then(function(data){
                    $modalInstance.close(data);
                });
            }
        };

        $scope.changeLocation = function(){
            if ($scope.data.selectedLocation.name !== '最后面' && $scope.data.selectedLocation.name !== '最前面') {
                $scope.status.isShowAfterTip = true;
            } else {
                $scope.status.isShowAfterTip = false;
            }
        }
    },
]);
